export enum ParametriaType {
  AGILCRED_RISK = 'AGILCRED_RISK',
  DNI_CHECK = 'DNI_CHECK',
  FORM_FEEDER_TTL_CACHE = 'FORM_FEEDER_TTL_CACHE',
  HOLDER_MATCH_PERCENTAGE = 'HOLDER_MATCH_PERCENTAGE',
  MAX_AUTOMATIC_PAYMENT_RETRIES = 'MAX_AUTOMATIC_PAYMENT_RETRIES',
  MINIMUM_ACCEPTABLE_AGE = 'MINIMUM_ACCEPTABLE_AGE',
  OPENBANKING_OWNER_ACCOUNTS_MIN_AGE = 'OPENBANKING_OWNER_ACCOUNTS_MIN_AGE',
  OPENBANKING_OWNER_ACCOUNTS_MIN_MATCH = 'OPENBANKING_OWNER_ACCOUNTS_MIN_MATCH',
  PAYLANDS_DEBT_PAYMENT_ORDER_EXPIRATION = 'PAYLANDS_DEBT_PAYMENT_ORDER_EXPIRATION',
  PAYLANDS_LOAN_PAYMENT_ORDER_EXPIRATION = 'PAYLANDS_LOAN_PAYMENT_ORDER_EXPIRATION',
  PAYLANDS_LOAN_PAYMENT_ORDER_MAX_ATTEMPTS = 'PAYLANDS_LOAN_PAYMENT_ORDER_MAX_ATTEMPTS',
  RISK_CACHE_DAYS = 'RISK_CACHE_DAYS',
  SANCTIONS_IO_PARAMS = 'SANCTIONS_IO_PARAMS',
  SEND_PDF_EMAIL_BCC = 'SEND_PDF_EMAIL_BCC',
  VERIDAS_MAX_ATTEMPTS = 'VERIDAS_MAX_ATTEMPTS',
  VERIDAS_MIN_SCORE = 'VERIDAS_MIN_SCORE',
  VERIDAS_OCR_MIN_MATCH = 'VERIDAS_OCR_MIN_MATCH',
  XPRESSID_REQUEST_BODY = 'XPRESSID_REQUEST_BODY',
  IS_DEBIT_CARD_REQUIRED = 'IS_DEBIT_CARD_REQUIRED ',
  IS_MISSING_CARD_STOP = 'IS_MISSING_CARD_STOP',
  IS_CONTRACT_VALIDATION_REQUIRED = 'IS_CONTRACT_VALIDATION_REQUIRED',
  IS_PLATFORM_IN_MAINTENANCE = 'IS_PLATFORM_IN_MAINTENANCE',
}

export interface Parametria<T> {
  id: bigint;
  nombre: ParametriaType;
  valor: T;
  tipo: 'string' | 'number' | 'boolean' | 'object';
  notas: string | null;
}
